export default __webpack_public_path__ + "media/images/dashboard_icons/offers-discounts-6df6c553ad4f485377bbdf01858001bc.svg";